<p-button
  [type]="type"
  styleClass="p-button-rounded"
  [style]="{ width: width, height: height }"
  [label]="label ? label : ''"
  [disabled]="disabled"
  (click)="onClick()"
></p-button>
